import { render, staticRenderFns } from "./HackathonCard.vue?vue&type=template&id=6c2b96a0&scoped=true&"
import script from "./HackathonCard.vue?vue&type=script&lang=js&"
export * from "./HackathonCard.vue?vue&type=script&lang=js&"
import style0 from "./HackathonCard.vue?vue&type=style&index=0&id=6c2b96a0&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b96a0",
  null
  
)

export default component.exports